import { ITransactionStatus } from '~/@api/generated-api-types-account/Api'

const labelsByStatus = {
  [ITransactionStatus.Cancelled]: 'Zrušená',
  [ITransactionStatus.Confirmed]: 'Potvrdená',
  [ITransactionStatus.Pending]: 'Čakajúca',
} as const

export function getTransactionStatusLabel(statusId: ITransactionStatus) {
  return labelsByStatus[statusId]
}
